import { DecimalPipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filesize'
})
export class FilesizePipe implements PipeTransform {
  decimalPipe: DecimalPipe;

  private units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

  constructor(@Inject(LOCALE_ID) localeId) {
    this.decimalPipe = new DecimalPipe(localeId);
  }

  transform(bytes: number = 0, precision: number = 2): string {
    if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes)) {
      return '?';
    }
    let unit = 0;
    while (bytes >= 1024) {
      bytes /= 1024;
      unit++;
    }
    if (unit === 0) {
      precision = 0;
    }
    return this.decimalPipe.transform(bytes, '1.1-' + precision) + ' ' + this.units[unit];
  }
}
